import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    update: async ({ password, password_confirmation, reset_password_token }, handleRedirect = null) => {
        const url = "/users/password";

        const body = JSON.stringify({
            user: {
                password,
                password_confirmation,
                reset_password_token,
            }
        });

        try {
            const response = await fetch(url, {
                method: "PUT",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            });

            return await handleResponse(response, handleRedirect);
        } catch (error) {
            return handleErrors(error);
        }
    },
    generateResetToken: async (handleRedirect = null) => {
        const url = "/users/generate_reset_token";
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            });

            return await handleResponse(response, handleRedirect);
        } catch (error) {
            return handleErrors(error);
        }
    }
}